import styled from 'styled-components';

const BUTTON_SIZE_PX = '14px';

export const Wrapper = styled.div`
  height: ${BUTTON_SIZE_PX};
  width: ${BUTTON_SIZE_PX};
`;

export const Button = styled.button`
  align-items: center;
  background-color: var(--base-bg-primary);
  border: var(--border-b-seed) solid var(--base-border-secondary);
  border-radius: var(--border-r-circle);
  display: flex;
  height: ${BUTTON_SIZE_PX};
  justify-content: center;
  padding: var(--layout-sandgrain);
  width: ${BUTTON_SIZE_PX};

  &:hover {
    background-color: var(--control-bg-decorative-hover);
    cursor: pointer;
  }

  &:focus-visible {
    background-color: var(--control-bg-decorative-hover);
    outline: var(--border-b-soybean) solid var(--action-border-focus-ring);
  }

  &:disabled {
    background-color: var(--base-bg-primary);
    outline: none;
  }
`;

export const UnreadDot = styled.div`
  background-color: var(--action-text-primary);
  border-radius: var(--border-r-circle);
  height: 8px;
  width: 8px;

  &:hover {
    // TODO(jbellmont): Replace colour when toolkit is updated.
    background-color: var(--control-bg-information-emphasis);
  }
`;
